import useCheckAccessRights from './accessCheck/useCheckAccessRights'
import useCheckModuleAccess from './accessCheck/useCheckModuleAccess'

const checkAccessAndRights = (subscription, userRight) => {
  const access = useCheckModuleAccess(subscription)
  const rights = useCheckAccessRights(userRight)
  return access && rights
}

export default checkAccessAndRights
